// src/pages/favoritos/Favoritos.tsx
import PageContainer from "shared/components/pagecontainer/PageContainer";
import styles from './Configuracoes.module.scss';
import { Bell, Settings, Globe, Wallet, MessageCircleQuestionMark } from "lucide-react";
export const Configuracoes: React.FC = () => {

  return (
    <PageContainer title="Configurações" icon={<Settings size={18} />}>
      <div className={styles.page}>
        <div className={styles.Abas}>
          <Bell color="#2B2B2B" size={22}/>
          <div className={styles.containerNomeeSub}>
            <p className={styles.titulo}>Notificações</p>
            <p className={styles.subTitulo}>Gerencie usas preferências</p>
          </div>
        </div>
        <div className={styles.Abas}>
          <Settings color="#2B2B2B" size={22}/>
          <div className={styles.containerNomeeSub}>
            <p className={styles.titulo}>Privacidade e Segurança</p>
            <p className={styles.subTitulo}>Controle seus dados</p>
          </div>
        </div>
        <div className={styles.Abas}>
          <Globe color="#2B2B2B" size={22}/>
          <div className={styles.containerNomeeSub}>
            <p className={styles.titulo}>Idioma e Região</p>
            <p className={styles.subTitulo}>Português (Brasil)</p>
          </div>
        </div>
        <div className={styles.Abas}>
          <Wallet color="#2B2B2B" size={22}/>
          <div className={styles.containerNomeeSub}>
            <p className={styles.titulo}>Forma de Pagamento</p>
            <p className={styles.subTitulo}>Gerencie seus métodos</p>
          </div>
        </div>
        

      </div>
    </PageContainer>
  );
};
